const secretKey = "3t6w9y$B&E)H@McQfTjWnZr4u7x!A%C*F-JaNdRgUkXp2s5v8y/B?E(G+KbPeShV" ;

const CryptoJS = require("crypto-js");

export const validEmail = new RegExp(
    '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
 );

export const validName = /^[a-zA-Z\s]*$/;

export const validNumbers = /^[0-9\s]*$/;

// export const validDOB = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD format

export const validDOB = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;


export const validAdhar = new RegExp('^[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$');

export const decrptor = (value) => {

    var decrpedHash  = CryptoJS.AES.decrypt(value, secretKey);
    var originalText = decrpedHash.toString(CryptoJS.enc.Utf8);

    return  originalText;
} 

export const encyptor = (value) => {
    return CryptoJS.AES.encrypt(value, secretKey).toString()
}

export const maskingAdhaar = (value) => {
    let arr = value.split(" ");
    let aadhaar = "xxxx-xxxx-"
    aadhaar = aadhaar.concat(arr[2]);
    return aadhaar;
  } 

  export const maskPassportVID = (value) => {
    console.log(value);
    let l = value.length;

    if (l === 0) return "NA"

    if (l<=3) return value;

    let passport  = ""
    value = value.toString();
    let cap  = l-4 ;
    for (let i = 0 ; i< l ; i++) {
        if (i <= cap ) {
            passport=  passport.concat("x")
        } else  passport = passport.concat(value.charAt(i))
    }
    console.log(passport,"passp");
    return passport;

}
